

import LoadContents from "@/js/plugins/LoadContents";
import searchArea from "./search/area.js";
import searchStation from "./search/station.js";
import searchSchool from "./search/school.js";
import SearchMap from "./search/map/index.js";
import estateIndex from "./estate/index.js";
import estateDetail from "./estate/detail.js";
import homePopup from "./home/popup.js";
import homeFeaturePopup from "./home/feature-popup.js";
import homeSearchPopup from "./home/search-popup.js";
import homeSearchSubmit from "./home/search-submit.js";
import homeBannerSlider from "./home/banner-slider.js";
import homeHeroSlider from "./home/hero-slider.js";
import homeReleaseScroll from "./home/release-scroll.js";
import homePickupGallery from "./home/pickup-gallery.js";
import homePickupCards from "./home/pickup-cards.js";
import homePickupAlign from "./home/pickup-align.js";
import homeHeaderSticky from "./home/header-sticky.js";
import columnDetail from "./column/detail.js";

const pages = () => {
    // pickup / search など LoadContents 後始末は、Ajax 完了前にリスナ登録が必要
    homePickupCards();
    homePickupAlign();

    // .js-load-contents（data-endpoint）を持つ要素の遅延読み込み。
    // 読み込み完了は各要素の onLoadContents イベントで受け取る。
    new LoadContents();
    searchArea();
    searchStation();
    searchSchool();
    SearchMap();
    estateIndex();
    estateDetail();
    homeBannerSlider();
    homePopup();
    homeFeaturePopup();
    homeSearchPopup();
    homeSearchSubmit();
    homeHeroSlider();
    homeReleaseScroll();
    homePickupGallery();
    homeHeaderSticky();
    columnDetail();
};
export default pages;
